import React from "react"

const Paragraphs = ({ content, customClass }) => {
  return (content ? "" + content : "")
    .split("\n")
    .filter((item) => {
      return item.replace(/(\r\n|\n|\r)/gm, "")
    })
    .map((item, i) => {
      return item.trim() ? (
        <p
          className={customClass}
          key={i}
          dangerouslySetInnerHTML={{ __html: item }}
        ></p>
      ) : null
    })
}

export default Paragraphs
